import useAddress from '@/modules/company/hooks/useAddress/useAddress';
import Display from '@/shared/modules/address/views/display/display';
import React, { useEffect } from 'react';

import useCompany from '@/shared/hooks/useCompany/useCompany';
import ICONS from '@/shared/entities/constants/icons';

const Address: React.FC = () => {
  const { company } = useCompany();
  const { isLoading, address, loadAddress } = useAddress();

  useEffect(() => {
    if (!company.id) {
      return;
    }
    loadAddress(company.id);
  }, [company.id, loadAddress]);

  return (
    <Display title='Endereço' icon={ICONS.ADDRESS} isLoading={isLoading} address={address[0]} />
  );
};

export default Address;
